/* Kaggaba Page: isolated section lifecycle, native commerce and direct purchase CTAs. */
(function () {
  'use strict';
  if (window.__kaggabaPageController) return;
  window.__kaggabaPageController = true;
  var roots = new Map();
    /* Actual-variant purchase forms are also the no-JS fallback. Each native
   * form owns its own valid selling_plan options; no option tuple inference. */
  function initCommerce(root, cleanups) {
    root.querySelectorAll('[data-spm-commerce]').forEach(function (commerce) {
      initCommerceInstance(root, commerce, cleanups);
    });
  }
  function initCommerceInstance(root, commerce, cleanups) {
    // Keep the native forms visible when enhancement capabilities are absent.
    if (!window.fetch || !window.FormData) return;
    var imageRoot = commerce.closest('[data-spm-buy-card]') || root;
    var choices = Array.prototype.slice.call(commerce.querySelectorAll('[data-spm-variant-choice]'));
    var panes = Array.prototype.slice.call(commerce.querySelectorAll('[data-spm-variant-pane]'));
    // An incomplete app/editor render must leave the native forms alone and
    // must not interrupt initialization of another card or section on the Page.
    if (!panes.length || panes.some(function (pane) {
      var form = pane.querySelector('[data-spm-purchase-form]');
      return !form || !form.querySelector('[data-spm-atc]') || !form.querySelector('[data-spm-error]');
    })) return;
    var pending = false;
    var selectedId = commerce.getAttribute('data-default-variant');
    var quantity = '1';
    var selectedPlan = null;
    var explicitPlan = null;
    var requestedTrigger = null;
    var active = true;
    var remoteFeedback = [];
    // Campaign sample wording is opt-in. Numeric variant pricing, never the
    // display title or a discounted subscription price, identifies the sample.
    var sampleOffer = commerce.getAttribute('data-spm-sample-offer') !== null;
    function sampleSelected(form, option) {
      var pane = form.closest('[data-spm-variant-pane]');
      return sampleOffer && pane.getAttribute('data-spm-variant-price') === '0' &&
        pane.getAttribute('data-spm-requires-plan') !== 'true' && (!option || !option.value);
    }
    function publishSelection(form, option) {
      if (!sampleOffer || form.closest('[data-spm-variant-pane]').getAttribute('data-variant-id') !== selectedId) return;
      var sample = sampleSelected(form, option);
      commerce.setAttribute('data-spm-sample-selected', String(sample));
      root.querySelectorAll('[data-spm-sample-copy]').forEach(function (node) { node.hidden = !sample; });
      commerce.dispatchEvent(new CustomEvent('spm:purchase-selection', {bubbles: true}));
    }

    function listen(node, type, callback) {
      node.addEventListener(type, callback);
      cleanups.push(function () { node.removeEventListener(type, callback); });
    }
    function selectedOption(select) {
      return select && select.options[select.selectedIndex];
    }
    function feedbackFor(trigger) {
      var entry = remoteFeedback.filter(function (item) { return item.trigger === trigger; })[0];
      if (!entry) {
        var status = trigger.ownerDocument.createElement('p');
        status.setAttribute('data-spm-purchase-status', '');
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        trigger.insertAdjacentElement('afterend', status);
        entry = { trigger: trigger, status: status, busy: trigger.getAttribute('aria-busy'), waiting: false };
        remoteFeedback.push(entry);
      }
      return entry;
    }
    function feedback(trigger, message, waiting) {
      var entry = feedbackFor(trigger);
      entry.status.textContent = message;
      entry.waiting = !!waiting;
      if (waiting) trigger.setAttribute('aria-busy', 'true');
    }
    function restoreTrigger(entry) {
      if (entry.busy === null) entry.trigger.removeAttribute('aria-busy');
      else entry.trigger.setAttribute('aria-busy', entry.busy);
      entry.waiting = false;
    }
    function finishFeedback(message) {
      remoteFeedback.forEach(function (entry) {
        if (!entry.waiting) return;
        entry.status.textContent = message;
        restoreTrigger(entry);
      });
    }
    function revealForm(form, control) {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      form.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      if (control) control.focus({ preventScroll: true });
    }
    function updateForm(form) {
      var selector = form.querySelector('[data-spm-plan]');
      var option = selectedOption(selector);
      // Also preserve omission if the browser falls back to a native submit.
      if (selector) {
        if (option && option.value) selector.setAttribute('name', 'selling_plan');
        else selector.removeAttribute('name');
      }
      var price = form.querySelector('[data-spm-price]');
      var compare = form.querySelector('[data-spm-compare]');
      var button = form.querySelector('[data-spm-atc]');
      var text = form.querySelector('[data-spm-atc-text]');
      var available = form.getAttribute('data-available') === 'true';
      if (selector && (!option || (selector.required && !option.value))) available = false;
      if (price && option) price.textContent = option.getAttribute('data-price') || '';
      if (compare && option) {
        compare.textContent = option.getAttribute('data-compare') || '';
        compare.hidden = !compare.textContent;
      }
      if (price && compare) price.classList.toggle('spm-price--sale', !compare.hidden);
      if (button) button.disabled = pending || !available;
      if (text) {
        var prefix = sampleOffer ? text.getAttribute(sampleSelected(form, option) ? 'data-spm-sample-label' : 'data-spm-paid-label') : text.getAttribute('data-prefix');
        text.textContent = available ? prefix : text.getAttribute('data-soldout-label');
        if (available && text.getAttribute('data-mode') === 'landing') {
          text.textContent += ' — ' + text.getAttribute('data-variant-label') + ' · ' + (price ? price.textContent : '');
        }
      }
      publishSelection(form, option);
      form.querySelectorAll('[data-spm-plan-detail]').forEach(function (detail) {
        detail.hidden = !option || detail.getAttribute('data-spm-plan-detail') !== option.value;
      });
    }
    function selectVariant(id, preserveSelection) {
      var target = panes.filter(function (pane) { return pane.getAttribute('data-variant-id') === id; })[0];
      if (!target) return;
      selectedId = id;
      panes.forEach(function (pane) { pane.hidden = pane !== target; });
      choices.forEach(function (choice) {
        choice.checked = choice.value === id;
        var label = choice.closest('[data-spm-choice-label]');
        if (label) label.classList.toggle('on', choice.checked);
      });
      var form = target.querySelector('[data-spm-purchase-form]');
      var qty = form.querySelector('[data-spm-qty]');
      if (qty) qty.value = quantity;
      var plan = form.querySelector('[data-spm-plan]');
      var planChange = form.querySelector('[data-spm-plan-change]');
      if (planChange) planChange.hidden = true;
      // Carry an explicit plan choice only when allocated to this variant.
      if (preserveSelection && plan && selectedPlan !== null) {
        var match = Array.prototype.slice.call(plan.options).some(function (option) { return option.value === selectedPlan; });
        plan.selectedIndex = match ? Array.prototype.findIndex.call(plan.options, function (option) { return option.value === selectedPlan; }) : 0;
        if (!match && selectedPlan && planChange) planChange.hidden = false;
      } else if (preserveSelection && !plan && selectedPlan && planChange) {
        planChange.hidden = false;
      }
      selectedPlan = plan ? plan.value : '';
      if (!preserveSelection || explicitPlan !== selectedPlan) explicitPlan = null;
      updateForm(form);
      var image = imageRoot.querySelector('[data-spm-variant-image]');
      if (image && target.getAttribute('data-image')) {
        image.src = target.getAttribute('data-image');
        image.alt = image.getAttribute('data-spm-image-alt') || target.getAttribute('data-image-alt') || '';
        image.removeAttribute('srcset');
      }
    }

    panes.forEach(function (pane) {
      var form = pane.querySelector('[data-spm-purchase-form]');
      var plan = form.querySelector('[data-spm-plan]');
      var qty = form.querySelector('[data-spm-qty]');
      var error = form.querySelector('[data-spm-error]');
      var button = form.querySelector('[data-spm-atc]');
      if (plan) listen(plan, 'change', function () {
        selectedPlan = plan.value;
        explicitPlan = plan.value;
        var notice = form.querySelector('[data-spm-plan-change]');
        if (notice) notice.hidden = true;
        updateForm(form);
      });
      if (qty) listen(qty, 'input', function () { quantity = qty.value; });
      [['[data-spm-qty-minus]', -1], ['[data-spm-qty-plus]', 1]].forEach(function (pair) {
        var stepper = form.querySelector(pair[0]);
        if (!stepper || !qty) return;
        stepper.hidden = false;
        listen(stepper, 'click', function () {
          var value = parseInt(qty.value, 10);
          qty.value = String(Math.max(1, (isNaN(value) ? 1 : value) + pair[1]));
          quantity = qty.value;
        });
      });
      form.querySelectorAll('[data-spm-live-price]').forEach(function (price) { price.hidden = false; });
      updateForm(form);

      // Native action remains usable if fetch/FormData are missing.
      if (!window.fetch || !window.FormData) return;
      listen(form, 'submit', function (event) {
        var cartAddUrl = root.getAttribute('data-cart-add-url') || form.getAttribute('action');
        if (!cartAddUrl) return;
        event.preventDefault();
        if (pending || button.disabled || !form.reportValidity()) return;
        pending = true;
        if (requestedTrigger) feedback(requestedTrigger, 'Adding to cart…', true);
        error.hidden = true;
        error.textContent = '';
        button.setAttribute('aria-busy', 'true');
        panes.forEach(function (item) { updateForm(item.querySelector('[data-spm-purchase-form]')); });
        var request;
        try {
          var body = new FormData(form);
          // Shopify accepts an omitted selling_plan for one-time purchases.
          if (body.get('selling_plan') === '') body.delete('selling_plan');
          var url = cartAddUrl.replace(/\.js$/, '') + '.js';
          request = fetch(url, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: body
          });
        } catch (failure) { request = Promise.reject(failure); }
        Promise.resolve(request).then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add to cart. Please try again.');
            return payload;
          });
        }).then(function () {
          if (active) finishFeedback('Added to cart.');
          window.dispatchEvent(new CustomEvent('cart-updated'));
          window.dispatchEvent(new CustomEvent('toggle-cart'));
        }).catch(function (failure) {
          if (active) {
            error.textContent = failure && failure.message ? failure.message : 'Unable to add to cart. Please try again.';
            error.hidden = false;
            finishFeedback(error.textContent);
          }
        }).then(function () {
          pending = false;
          if (active) {
            button.removeAttribute('aria-busy');
            panes.forEach(function (item) { updateForm(item.querySelector('[data-spm-purchase-form]')); });
          }
        });
      });
    });
    choices.forEach(function (choice) {
      listen(choice, 'change', function () { if (choice.checked && !choice.disabled) selectVariant(choice.value, true); });
    });
    listen(commerce, 'spm:purchase-request', function (event) {
      var trigger = event.detail && event.detail.trigger;
      var pane = panes.filter(function (item) { return item.getAttribute('data-variant-id') === selectedId; })[0];
      var form = pane && pane.querySelector('[data-spm-purchase-form]');
      // Leave the caller's product-link fallback intact without a usable bridge.
      if (!trigger || !trigger.ownerDocument || !form || typeof form.requestSubmit !== 'function' ||
          !(root.getAttribute('data-cart-add-url') || form.getAttribute('action'))) return;
      event.preventDefault();
      if (pending) { feedback(trigger, 'Adding to cart…', true); return; }
      feedback(trigger, '', false);
      updateForm(form);
      var button = form.querySelector('[data-spm-atc]');
      var plan = form.querySelector('[data-spm-plan]');
      if (button.disabled) { feedback(trigger, 'This purchase option is unavailable.', false); return; }
      // A remote CTA must never silently enroll a required subscription.
      if (plan && plan.required && (!explicitPlan || explicitPlan !== plan.value)) {
        feedback(trigger, 'Choose a purchase option before adding to cart.', false);
        revealForm(form, plan);
        return;
      }
      if (!form.reportValidity()) {
        feedback(trigger, 'Review the quantity and purchase options before adding to cart.', false);
        revealForm(form, form.querySelector('[data-spm-qty]') || plan || button);
        return;
      }
      requestedTrigger = trigger;
      try {
        form.requestSubmit(button);
        if (!pending) feedback(trigger, 'Review the purchase options before adding to cart.', false);
      } catch (failure) {
        feedback(trigger, 'Unable to add to cart. Please try again.', false);
      } finally { requestedTrigger = null; }
    });
    // No form is hidden until every form has been initialized successfully.
    commerce.classList.add('spm-commerce--enhanced');
    commerce.querySelectorAll('[data-spm-native-forms]').forEach(function (node) { node.hidden = true; });
    commerce.querySelectorAll('[data-spm-enhanced-form]').forEach(function (node) { node.hidden = false; });
    var chooser = commerce.querySelector('[data-spm-choices]');
    if (chooser) chooser.hidden = choices.length < 2;
    if (!panes.some(function (pane) { return pane.getAttribute('data-variant-id') === selectedId; })) selectedId = panes[0].getAttribute('data-variant-id');
    selectVariant(selectedId, false);
    cleanups.push(function () {
      active = false;
      if (sampleOffer) {
        commerce.removeAttribute('data-spm-sample-selected');
        root.querySelectorAll('[data-spm-sample-copy]').forEach(function (node) { node.hidden = true; });
      }
      remoteFeedback.forEach(function (entry) { restoreTrigger(entry); entry.status.remove(); });
      remoteFeedback = [];
      panes.forEach(function (pane) { pane.querySelector('[data-spm-atc]').removeAttribute('aria-busy'); });
      commerce.classList.remove('spm-commerce--enhanced');
      commerce.querySelectorAll('[data-spm-native-forms]').forEach(function (node) { node.hidden = false; });
      commerce.querySelectorAll('[data-spm-enhanced-form]').forEach(function (node) { node.hidden = true; });
      if (chooser) chooser.hidden = true;
      panes.forEach(function (pane) { pane.hidden = false; });
    });
  }

  function init(root) {
    if (roots.has(root)) return;
    var cleanups = [];
    roots.set(root, cleanups);
    initCommerce(root, cleanups);
  }
  function scan() {
    document.querySelectorAll('.spm-page--kaggaba-landing-page[data-kg-section]').forEach(init);
    roots.forEach(function (cleanups, root) {
      if (!root.isConnected) {
        cleanups.forEach(function (fn) { fn(); });
        roots.delete(root);
      }
    });
    refreshClaims();
  }
  function nearestBuy(link, excluded) {
    var candidates = Array.from(document.querySelectorAll('.spm-page--kaggaba-landing-page [data-kg-buy][data-kg-available="true"]'))
      .filter(function (target) {
        return target.getClientRects().length > 0 && target.getAttribute('data-kg-product-url') &&
          !(excluded && excluded.contains(target));
      });
    var ownRoot = link.closest('[data-kg-section]');
    return candidates.find(function (target) { return ownRoot && ownRoot.contains(target); }) ||
      candidates.find(function (target) { return link.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_FOLLOWING; }) ||
      candidates[candidates.length - 1];
  }
  function syncClaim(link, excluded) {
    var target = nearestBuy(link, excluded);
    var slot = link.closest('[data-kg-claim-slot]');
    var note = slot && slot.querySelector('[data-kg-claim-note]');
    link.hidden = !target;
    // Shopify's editor intercepts product URLs before this purchase handler.
    // A real section anchor keeps editor clicks inside the preview; handled
    // purchase requests still prevent the anchor's default navigation.
    if (target) link.setAttribute('href', window.Shopify && window.Shopify.designMode ? '#' + target.id : target.getAttribute('data-kg-product-url'));
    else link.removeAttribute('href');
    if (target) {
      var commerce = target.querySelector('[data-spm-commerce]');
      if (commerce && commerce.getAttribute('data-spm-sample-offer') !== null) {
        // Cache each merchant's saved sample copy once, so paid -> free can
        // restore it even when sections are duplicated, reordered or reloaded.
        if (link.getAttribute('data-kg-sample-label') === null) link.setAttribute('data-kg-sample-label', link.textContent);
        link.textContent = commerce.getAttribute('data-spm-sample-selected') === 'true' ?
          link.getAttribute('data-kg-sample-label') : commerce.getAttribute('data-spm-paid-label') || 'Add to cart';
      }
    }
    if (note) note.hidden = !!target;
    return target;
  }
  function refreshClaims(excluded) {
    document.querySelectorAll('.spm-page--kaggaba-landing-page a[data-kg-claim]').forEach(function (link) {
      syncClaim(link, excluded);
    });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.spm-page--kaggaba-landing-page a[data-kg-claim]');
    if (!link || event.defaultPrevented) return;
    var target = syncClaim(link);
    if (!target) { event.preventDefault(); return; }
    if ((event.button !== undefined && event.button !== 0) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        link.hasAttribute('target') || link.hasAttribute('download')) return;
    // The first commerce instance is this Product section's primary purchase
    // form. Its own handler retains variant/plan selection and cart safeguards.
    var commerce = target.querySelector('[data-spm-commerce]');
    if (!commerce) return;
    var request = new CustomEvent('spm:purchase-request', {cancelable: true, detail: {trigger: link}});
    commerce.dispatchEvent(request);
    if (request.defaultPrevented) event.preventDefault();
  });
  document.addEventListener('spm:purchase-selection', function () { refreshClaims(); });
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:reorder', scan);
  document.addEventListener('shopify:section:select', scan);
  document.addEventListener('shopify:section:deselect', scan);
  document.addEventListener('shopify:section:unload', function (event) {
    roots.forEach(function (cleanups, root) {
      if (event.target.contains(root)) {
        cleanups.forEach(function (fn) { fn(); });
        roots.delete(root);
      }
    });
    // Shopify can emit unload before detaching the old section node.
    refreshClaims(event.target);
  });
  window.addEventListener('resize', function () { refreshClaims(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true});
  else scan();
})();
